import { $, $$ } from 'utils/dom';
import Swiperslider from 'modules/swiper/swiper';

const startHeaders = $$('.start-header');

if (startHeaders.length) {
  startHeaders.forEach(startHeader => {
    const slides = $$('.swiper-slide', startHeader);

    if (slides.length === 1) return;

    const slider = new Swiperslider($('.start-header__slider', startHeader), {
      container: startHeader,
      sliderOptions: {
        spaceBetween: 0,
        lazy: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
    });
    slider.init();
  });
}

const videoButton = $('.start-header__video-button');
const video = $('.start-header__video video');

if (videoButton && video) {
  const playPauseVideo = () => {
    if (video.paused) {
      playVideo();
    } else {
      pauseVideo();
    }
  };

  const playVideo = () => {
    video.play();
    videoButton.classList.remove('is-paused');
  };

  const pauseVideo = () => {
    video.pause();
    videoButton.classList.add('is-paused');
  };

  videoButton.addEventListener('click', playPauseVideo);
}
